export type LoginStatus = {
    type: LoginState;
};

export enum LoginState {
    DISRUPTION = 'disruption',
    MAINTENANCE = 'maintenance'
}
